import { axios } from 'lib/axios';
import { toFormData } from './formData';
import { useQnaMutation } from './useQnaMutation';

const askQuestion = (resource, id, values) =>
  axios.post(`/api/${resource}/${id}/qna/questions`, toFormData(values));

export const useAskQuestion = (resource, id, onSuccess) =>
  useQnaMutation(resource, id, (values) => askQuestion(resource, id, values), {
    successMessage: 'Question sent',
    onSuccess,
  });
